import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setKpiMetricGoal,
  deleteKpiMetricGoal,
} from "store/kpi-config/KpiConfigActions";
import { selectPerformanceReportStoreId } from "store/performance-report/PerformanceReportSelectors";

export const useSetGoalHandler = (categoryId: string) => {
  const dispatch = useDispatch();
  const performanceStoreId = useSelector(selectPerformanceReportStoreId);

  const handleSetGoal = useCallback(
    (metricId: string, goal: number) => {
      if (performanceStoreId) {
        dispatch(
          setKpiMetricGoal({
            storeId: performanceStoreId,
            kpiMetricId: metricId,
            kpiMetricGoal: goal,
            categoryId,
          }),
        );
      }
    },
    [dispatch, performanceStoreId, categoryId],
  );

  return handleSetGoal;
};

export const useDeleteGoalHandler = (categoryId: string) => {
  const dispatch = useDispatch();
  const performanceStoreId = useSelector(selectPerformanceReportStoreId);

  const handleDeleteGoal = useCallback(
    (metricId: string) => {
      if (performanceStoreId) {
        dispatch(
          deleteKpiMetricGoal({
            storeId: performanceStoreId,
            kpiMetricId: metricId,
            categoryId,
          }),
        );
      }
    },
    [dispatch, performanceStoreId, categoryId],
  );

  return handleDeleteGoal;
};
